import { Accepts, Types } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class CompassProps {
  @Inlet(Accepts.MarkdownText) public text!: Types["MarkdownText"];
  @Inlet(Accepts.GeoLocation) public target!: Types["GeoLocation"];

  /* Distance from marker action */
  @Outlet({
    arguments: {
      // Accepts number
      distance: Accepts.Number,
    },
  })
  public distanceFromTarget!: (value: { distance: Types["Number"] }) => void;
}

export const CompassDefinition = defineElement("compass", CompassProps, {
  versionRequired: "0.8.0",
});
